<oaibox-warning-message-card confirmText="Delete" gradient="danger" (confirm$)="deleteClient()" (cancel$)="cancel()">
  <div messageTitle>Are you sure you want to delete this deployment?</div>

  <div messageBody class="content">
    <oaibox-deployment-details [tenant]="tenant"></oaibox-deployment-details>
  </div>
</oaibox-warning-message-card>
